import type { SurfaceProps } from './types';
import { surfaceFilled } from './types';

/**
 * Таблица / матрица (строгая 2D-форма). Колонки — из config.tableColumns.
 * Строки динамические (добавить/убрать). Под RTM, decision table, матрицу доступов,
 * EP/BVA, метрики и т.п. Полная строка — когда заполнены все колонки.
 */
export function TableForm({ spec, value, disabled, onChange }: SurfaceProps) {
  const cols = spec.config?.tableColumns ?? ['Колонка 1', 'Колонка 2'];
  const rawRows = Array.isArray(value?.rows) ? (value!.rows as string[][]) : [];
  // нормализуем строки под число колонок (на случай изменения конфигурации)
  const rows: string[][] = (rawRows.length ? rawRows : [cols.map(() => ''), cols.map(() => '')])
    .map((r) => cols.map((_, ci) => (Array.isArray(r) ? r[ci] ?? '' : '')));

  const emit = (next: string[][]) => onChange({ rows: next }, surfaceFilled(spec, { rows: next }));
  const setCell = (ri: number, ci: number, val: string) => {
    const next = rows.map((r, i) => (i === ri ? r.map((cell, j) => (j === ci ? val : cell)) : r));
    emit(next);
  };
  const addRow = () => emit([...rows, cols.map(() => '')]);
  const removeRow = (ri: number) => emit(rows.filter((_, i) => i !== ri));

  return (
    <div className="surf surf-table" data-testid="surf-table">
      <div className="surf-tag">Таблица</div>
      <div className="tbl-scroll">
        <table className="tbl">
          <thead>
            <tr>
              {cols.map((c, i) => (
                <th key={i}>{c}</th>
              ))}
              {!disabled && <th className="tbl-act" aria-label="действия" />}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>
                    <input
                      value={cell}
                      disabled={disabled}
                      data-testid={`tbl-cell-${ri}-${ci}`}
                      aria-label={`${cols[ci]}, строка ${ri + 1}`}
                      onChange={(e) => setCell(ri, ci, e.target.value)}
                    />
                  </td>
                ))}
                {!disabled && (
                  <td className="tbl-act">
                    {rows.length > 1 && (
                      <button type="button" className="rm" aria-label="убрать строку"
                        onClick={() => removeRow(ri)}>×</button>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!disabled && (
        <button type="button" className="surf-add" data-testid="tbl-add-row" onClick={addRow}>
          + строка
        </button>
      )}
    </div>
  );
}
